<template>

  <v-card>

    <v-row dense class="pa-2 align-center">

      <v-col cols="6">
      </v-col>

      <v-col cols="6" class="d-flex text-right align-center">
        <v-text-field
          v-model="searchQuery"
          append-icon="mdi-magnify"
          @click:append="getProducts"
          solo
          rounded
          hide-details
          dense
          clearable
          placeholder="검색"
          @keyup.enter="getProducts"
        ></v-text-field>
        <v-btn
          :loading="isLoading"
          icon
          small
          class="ml-2"
          @click="reloadSearch"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>

    </v-row>

    <v-data-table
      v-model="selected"
      single-select
      show-select
      :headers="headers"
      :items="products"
      class="flex-grow-1"
      :server-items-length="totalItems"
      :options.sync="options"
      item-key="productId"
      :footer-props="{showFirstLastPage: true}"
      disable-sort
      @item-selected="selectProduct"
    >
      <template v-slot:item.category="{ value }">
        {{value.categoryName}}
      </template>

      <template v-slot:item.createdAt="{ value }">
        <div>{{ value | moment('YYYY-MM-DD HH:mm:ss') }}</div>
      </template>

    </v-data-table>

  </v-card>

</template>

<script>
import ProductApi from "@/api/ProductApi"

export default {
  components: {
  },
  props: {
    selectedProductId: {
      type: Number
    },
    selectedProduct: {
      type: Array
    }
  },
  data() {
    return {
      selected:[],
      isLoading: false,
      searchQuery: '',
      waitingSearch: false,
      selectedUsers: [],
      headers: [
        { text: 'Id', align: 'left', value: 'productId' },
        { text: '분류', align: 'left', value: 'category' },
        { text: '제품명', align: 'left', value: 'productName' },
        { text: '생성일', value: 'createdAt' },
        { text: '가격', value: 'price' },
        { text: '', sortable: false, align: 'right', value: 'action' }
      ],
      options:{},
      param:{},
      totalItems: 0,
      products: []
    }
  },
  mounted() {
    this.selected = [{productId:this.selectedProductId}];
  },
  watch: {
    selectedProductId: {
      handler(nv) {
        this.selected = [{productId:nv}];
      },
      deep: true
    },
    selectedProduct: {
      handler(nv) {
        this.selected = nv;
      },
      deep: true
    },
    options: {
      handler() {
        this.getProducts();
      },
      deep: true,
    },
    searchQuery: {
      handler(nv) {
        this.param.searchKeyword = nv;
        if (!this.waitingSearch) {
          setTimeout(() => {
            this.getProducts();
            this.waitingSearch = false;
          }, 500); // 0.5 sec delay
        }
        this.waitingSearch = true;
      }
    },
  },
  methods: {
    selectProduct({item, value}) {
      if(value) {
        this.$emit('product-selected', item);
      }
    },
    reloadSearch() {
      this.param = {}
      this.searchQuery = ''
      this.getProducts()
    },
    getProducts() {
      const {  page, itemsPerPage, size } = this.options;
      let params = {...this.param, ...{
          page: page,
          size: size ? size : itemsPerPage
        }};
      if (this.param.searchDate?.length??0 > 0) {
        params.fromDate = this.param.searchDate[0];
        params.toDate = this.param.searchDate?.[1]??this.param.searchDate[0];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }

      // console.log(params);
      ProductApi.list(params).then(data => {
        this.totalItems = data.totalElements;
        this.products = data.content;
      })
    }
  },
  created() {
  }
}
</script>
